<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
        @click:row="selectRow"
        :footer-props="globalFooterOptions"
        :headers="headers"
        :items="items"
        :items-per-page="globalItemsPerPage"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        style="margin-bottom: 80px;"
        >
          <template v-slot:item.memberships="{ item }" >{{ userRoleDisplay(item.memberships, selectedSite._id) }}</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-btn :to="{name: 'userInvite'}" fab id="addButton" color="success"><v-icon>add</v-icon></v-btn>
  </v-container>

</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import { AuthMixins } from '@/shared/mixins'

export default {
  mixins: [AuthMixins],

  data () {
    return {
      headers: [
        { text: 'Display Name', value: 'nameDisplay' },
        { text: 'Email', value: 'email' },
        { text: 'Site Role', value: 'memberships', sortable: false }
      ],
      items: [],
      loading: false,
      options: {},
      totalItems: 0
    }
  },

  created () {
    this.getData()
  },

  computed: {
    ...mapGetters([
      'selectedSite',
      'isSiteSelected'
    ])
  },

  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },

  methods: {
    getData: function () {
      if (this.options.page !== undefined) {
        this.loading = true

        var params = {}
        if (this.options.itemsPerPage > 0) {
          params.page = this.options.page - 1
          params.limit = this.options.itemsPerPage
        }

        if (!this.isSiteSelected) {
          this.loading = false
          return
        }
        params.resource = this.selectedSite._id

        if (this.options.sortBy.length > 0) {
          params.sort = ''
          if (this.options.sortDesc[0]) {
            params.sort = '-'
          }
          params.sort = params.sort + this.options.sortBy[0]
        }

        ApiRequests.userQuery(params).then(r => {
          this.items = r.data
          this.totalItems = parseInt(r.headers['x-total-count'])
          this.loading = false
        })
      }
    },

    selectItem: function (item) {
      this.setSite(item)
    },

    selectRow: function (item) {
      this.$router.push({ name: 'userEdit', params: { id: item._id } })
    }
  }
}
</script>
